import { initializeApp } from 'firebase/app';
import { getMessaging } from 'firebase/messaging';
import firebaseCredentials from './firebaseCredentials.js';

// Log firebaseCredentials
// console.log('Firebase credentials:', firebaseCredentials);

const firebaseApp = initializeApp(firebaseCredentials);

export default getMessaging(firebaseApp);